import { axios } from '@/utils/request';

let Api = {
  demandDisassembly: '/tech/disassembly',
  demandDisassemblyV3: '/tech/disassembly_v3',
  demandNonstream: '/tech/demand_analysis_nonstream',
  demandAnalysis: '/tech/demand_analysis',
  recommendTech: '/tech/recommend_tech',
  demandAnalysisDetail: '/tech/get_demand_analysis_detail',
  modifyKeywords: '/tech/disassembly/modify_keywords',
  demandPdf: '/tech/pdf/', // 需求分析 导出PDF
  requirementPdfStatus: '/tech/pdf/status/', // 检查需求分析pdf是否可以下载
  getDisassemblyDetail: '/tech/get_demand_dis_detail',
};

/**
 * 修改关键词
 * @param params
 * @returns {*}
 */
export const modifyKeywordsApi = (params) => {
  return axios.post(Api.modifyKeywords,params);
};

/**
 * 获取推荐列表
 * @param params
 * @returns {*}
 */
export const getRecommendTechApi = (params) => {
  return axios.get(Api.recommendTech,{params});
};

// 需求拆解 v1
export const demandDisassemblyApi = (params) => {
  return axios.post(Api.demandDisassembly,params);
};

// 需求拆解 v3
export const demandDisassemblyV3Api = (params) => {
  return axios.post(Api.demandDisassemblyV3, params);
}

/**
 * 需求拆解
 * @param params
 * @returns {*}
 */
export const demandNonstreamApi = (params) => {
  return axios.post(Api.demandNonstream,params, {
    timeout: 600000
  });
};

// 需求分析 详情
export const demandAnalysisDetailApi = (params) => {
  return axios.get(Api.demandAnalysisDetail, { params });
}

// 需求分析 导出PDF
export const demandPdfApi = (id) => {
  return axios.get(Api.demandPdf + id);
}

// 检查需求分析pdf是否可以下载
export const requirementPdfStatusApi = (id) => {
  return axios.get(Api.requirementPdfStatus + id);
}

// 详情页获取需求拆解
export const getDisassemblyDetailApi = (params) => {
  return axios.get(Api.getDisassemblyDetail, { params });
}